<div class="twc-ml-3 twc-mt-2 twc-mb-3">
    <div *ngIf="label">
        <span class="twc-body"> {{label | translate}} </span>
    </div>
    <div>
        <twc-select [(ngModel)]="property.value" cwFindParentBoundary (ngModelChange)="onChange()"
            [disabled]="!property.editable()">
            <twc-select-option *ngFor="let option of options" [value]="option">
                {{ option | translate}}
            </twc-select-option>
        </twc-select>
    </div>
</div>